module.exports = __webpack_public_path__ + "img/1.228f4705.png";